import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://iahmppxelhvubobwqtqk.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlhaG1wcHhlbGh2dWJvYndxdHFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYyNTMyMjMsImV4cCI6MjA4MTgyOTIyM30.lFBMeoiKlxjfwhaDQtXMGrfm7sHFiI1BrxY5UQtV71o';

export const supabase = createClient(supabaseUrl, supabaseKey);
